// src/mocks/browser.js
import { setupWorker } from 'msw'
import { handlers } from './handlers'
import {
	resetRefreshMockState,
	setRefreshFailureCountBeforeSuccess,
} from './rest/login'

// This configures a Service Worker with the given request handlers.
export const worker = setupWorker(...handlers)

const triggerTokenRefresh = async () => {
	const { default: http } = await import('../store/common/axios')
	const response = await http.post(
		'/swc-api/token/refresh/',
		{ refresh: localStorage.getItem('auth/REFRESH_TOKEN') },
		{ withCredentials: true }
	)

	if (response?.data?.access) {
		localStorage.setItem('auth/ACCESS_TOKEN', response.data.access)
	}
	if (response?.data?.refresh) {
		localStorage.setItem('auth/REFRESH_TOKEN', response.data.refresh)
	}

	return response.data
}

const setRefreshFailureCount = (count) => {
	setRefreshFailureCountBeforeSuccess(count)
	resetRefreshMockState()
	return {
		refreshFailureCountBeforeSuccess: Math.max(0, Number(count) || 0)
	}
}

const resetRefreshState = () => {
	resetRefreshMockState()
	return { reset: true }
}

if (typeof window !== 'undefined') {
	window.swacMock = window.swacMock || {}
	window.swacMock.setRefreshFailureCount = setRefreshFailureCount
	window.swacMock.resetRefreshState = resetRefreshState
	window.swacMock.triggerTokenRefresh = triggerTokenRefresh
}
